module.exports = __webpack_public_path__ + "static/media/criteria-10.2.c5e0b56b.jpg";